import { render, staticRenderFns } from "./assist-manage-array.vue?vue&type=template&id=4484043f&scoped=true"
import script from "./assist-manage-array.vue?vue&type=script&lang=ts"
export * from "./assist-manage-array.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484043f",
  null
  
)

export default component.exports